import type { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { Capacitor } from '@capacitor/core';

import { NativeAuthStrategy } from './native';
import {
  type CodeExchangeResult,
  exchangeCodeForTokens,
} from './token-exchange';
import { WebAuthStrategy } from './web';

/**
 * Interface for authentication strategies
 */
export interface AuthStrategy {
  login(
    msalInstance: PublicClientApplication,
    getRedirectUri: () => string,
    msalConfig: { auth: { authority: string; clientId: string } },
  ): Promise<void>;
  logout(
    msalInstance: PublicClientApplication,
    getRedirectUri: () => string,
  ): Promise<void>;
}

/**
 * Get the appropriate authentication strategy based on platform
 */
export function getAuthStrategy(
  setUser: (
    account: AccountInfo,
    accessToken?: string,
    expiresOn?: Date,
  ) => void,
  initLocaleStorage: () => Promise<void>,
  redirectAfterLogin: () => Promise<void>,
  exchangeCodeForTokensFn: (
    code: string,
    codeVerifier: string,
    msalInstance: PublicClientApplication,
    getRedirectUri: () => string,
    msalConfig: { auth: { authority: string; clientId: string } },
  ) => Promise<CodeExchangeResult>,
): AuthStrategy {
  if (Capacitor.isNativePlatform()) {
    return new NativeAuthStrategy(
      setUser,
      initLocaleStorage,
      redirectAfterLogin,
      exchangeCodeForTokensFn,
    );
  }
  return new WebAuthStrategy(setUser, initLocaleStorage, redirectAfterLogin);
}

// Re-export for convenience
export { NativeAuthStrategy } from './native';
export { WebAuthStrategy } from './web';
export {
  exchangeCodeForTokens,
  refreshTokensWithRefreshToken,
} from './token-exchange';
